<template>
    <div v-if="data" class="table-que yx-start">
        <question-show :data="data.Content"></question-show>
        <div
            v-if="
                data.SubjectType === 1 ||
                data.SubjectType === 2 ||
                data.SubjectType === 4
            "
            class="yx-start"
        >
            <div v-for="(item, index) in data.AnswerList" :key="index">
                <question-show
                    :data="item.Content"
                >
                    <template v-slot:start>
                        {{String.fromCharCode(index + 65) + '、'}}
                    </template>
                </question-show>
            </div>
        </div>
        <div class="xy-center" style="margin-top: 5px">
            <span class="no-wrap"   >答案:</span>
            <question-show :data="data.Answer"></question-show>
        </div>
        <div class="xy-center" style="margin-top: 5px">
            <span class="no-wrap">解析:</span>
            <question-show :data="data.Analysis"></question-show>
        </div>
    </div>
</template>

<script>
import QuestionShow from "./QuestionShow.vue";
export default {
    components: { QuestionShow },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    created() {},
    mounted() {
        this.findRightAnswer();
    },
    watch: {
        data() {
            this.findRightAnswer();
        },
    },
    methods: {
        findRightAnswer() {
            if (!this.data) return;
            const queType = this.data.SubjectType;

            // console.log("arr:", arr);
            if (queType === 1 || queType === 2) {
                const arr = this.data.AnswerList.filter(
                    (item) => item.IsRight === 1
                ).map((item) => String.fromCharCode(64 + item.RankNum));
                this.data.Answer = arr.join("、");
                // console.log("这：", this.data.Answer);
            }
            if (queType === 4) {
                const arr = this.data.AnswerList.filter(
                    (item) => item.IsRight === 1
                ).map((item) => item.Content);
                this.data.Answer = arr.join("");
            }
            if (queType === 3 || queType === 5) {
                this.data.Answer = this.data.AnswerList.map(
                    (item) => item.Content
                ).join("|");
            }
        },
    },
};
</script>

<style lang="less" scoped>
.table-que {

}
</style>
